import {ResourceType} from '../../../@types/resource-type';
import {WorkspaceResource} from '../../../@types/workspace-types';
import {TreeViewItem} from '../../../@types/tree-view-item';
// Re-export for backward compatibility
import {generateTreeItems, getResourceNameWithAscendants} from '../../../utils/resource-utils';
import {BasicPage, defaultPageLarge} from '../../../@types/spring-data-page';
import SafetyModel from '../../../@types/safety-model';

/**
 * Determines if the group selector should be shown for a given resource type
 */
export function shouldShowGroupSelector(type: ResourceType): boolean {
    return type !== ResourceType.USERS && type !== ResourceType.SERVICE_USER_ACCOUNTS;
}

/**
 * Gets the default order by field for a resource type
 */
export function getDefaultOrderBy(type: ResourceType): string {
    const uniqueIdTypes = [ResourceType.OCCURRENCE_REPORTS, ResourceType.NEW_OCCURRENCE_REPORTS];
    return uniqueIdTypes.includes(type) ? 'uniqueId' : 'name';
}


/**
 * Converts workspace resources to tree view items
 */
export function convertToTreeViewItems(objects: WorkspaceResource | null): TreeViewItem[] {
    return generateTreeItems(objects?.resources ?? [], objects?.objectType ?? ResourceType.UNKNOWN);
}

/**
 * Creates a resources to select list items converter
 */
export function resourcesToSelectListItems(
    resources: Array<{id: number, [key: string]: any}> | null | undefined
): {id: number, name: string}[] {
    if (!resources) return [];
    
    return resources
        .map(resource => ({
            id: resource.id,
            name: getResourceNameWithAscendants(resource, ResourceType.GROUPS)
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
}

/**
 * Updates safety model children with proper roles
 */
export function updateSafetyModelChildren(safetyModel: SafetyModel): SafetyModel {
    if (safetyModel.children !== undefined && safetyModel.children.length > 0) {
        safetyModel.children.forEach(ess => ess.role = safetyModel.group.role());
    }
    return safetyModel;
}

/**
 * Creates parameters for loadObjects calls
 */
export interface LoadObjectsParams {
    page?: BasicPage;
    resource?: number;
    search?: string;
}

/**
 * Creates a default page configuration with sorting
 */
export function createDefaultPage(orderBy: string, order: 'asc' | 'desc'): BasicPage {
    return { ...defaultPageLarge, sort: orderBy, direction: order };
}

export { getResourceNameWithAscendants };